import { ReactNode, createContext, useContext, useEffect, useState } from 'react';

import services from 'services';
import { OfflineCacheState } from 'types';

import OfflineInfo from './OfflineInfo';

export type OfflineCacheContextType = {
  online: boolean;
};

export const OfflineCacheContext = createContext<OfflineCacheContextType>({} as OfflineCacheContextType);

type OfflineCacheProviderState = {
  online: boolean;
  cache: OfflineCacheState;
};

const OfflineCacheProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<OfflineCacheProviderState>({
    cache: services.appFrame.offline.getCacheState(),
    online: services.appFrame.offline.isOnline(),
  });
  useEffect(() => {
    const unsubscribeOnlineChange = services.appFrame.offline.onOnlineChange((online) => {
      setState((prevState) => ({ ...prevState, online }));
    });

    const unsubscribeCacheStateChange = services.appFrame.offline.onCacheStateChange((cache) => {
      setState((prevState) => ({ ...prevState, cache }));
    });

    return () => {
      unsubscribeOnlineChange();
      unsubscribeCacheStateChange();
    };
  });

  return (
    <OfflineCacheContext.Provider value={state}>
      {!state.online && !state.cache.found && (
        <div style={state.cache.offlineContainerStyle}>
          <OfflineInfo />
        </div>
      )}
      {children}
    </OfflineCacheContext.Provider>
  );
};

export const useOfflineCache = () => useContext(OfflineCacheContext);

export default OfflineCacheProvider;
